import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-custom-confirm-modal',
  imports: [CommonModule],
  templateUrl: './custom-confirm-modal.component.html',
  styleUrls: ['./custom-confirm-modal.component.scss']
})
export class CustomConfirmModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Confirm Action';
  @Input() message: string = '';
  @Input() confirmLabel: string = 'Confirm';
  @Input() cancelLabel: string = 'Cancel';
  @Input() allowOverlayClose: boolean = true;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
    this.isVisible = false;
  }

  onCancel(): void {
    this.cancel.emit();
    this.isVisible = false;
  }

  onOverlayClick(event: Event): void {
    if (this.allowOverlayClose) {
      this.onCancel();
    }
  }
}
